import { render, staticRenderFns } from "./EditablePrice.vue?vue&type=template&id=0625a6e7&"
import script from "./EditablePrice.vue?vue&type=script&lang=js&"
export * from "./EditablePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports